import { autoserializeAs } from 'cerialize'
import { DateSerializer } from '@/helpers/model-utils'
import { Customer, emptyCustomer, IDocument, DocumentType } from './interfaces'
import Revenue from './revenue'

const ONE_DAY_MS = 1000 * 60 * 60 * 24

export default class Invoice implements IDocument {

  @autoserializeAs('id')
  public id: string = ''

  @autoserializeAs('code')
  public code: string = ''

  @autoserializeAs(DateSerializer, 'date')
  public issueDate: Date = new Date()

  @autoserializeAs('customer')
  public customer: Customer = emptyCustomer()

  @autoserializeAs(Revenue, 'items')
  public items: Revenue[] = []

  @autoserializeAs('total_amount')
  public totalAmount: number = 0

  @autoserializeAs('total_vat')
  public totalVat: number = 0

  @autoserializeAs(DateSerializer, 'last_updated')
  public lastUpdated: Date = new Date()

  public constructor(invoice?: Invoice) {
    if (invoice) {
      this.id = invoice.id
      this.code = invoice.code
      this.issueDate = invoice.issueDate
      this.customer = {...invoice.customer}
      this.items = [...invoice.items]
      this.totalAmount = this.items.reduce((a, b) => a + b.total, 0)
      this.totalVat = this.items.reduce((a, b) => a + b.totalVat, 0)
    }
  }

  public get idealReceiptIssueDate(): Date {
    return new Date(this.issueDate.getTime() + ONE_DAY_MS)
  }

  public set(customer: Customer) {
    if (this.customer.code !== customer.code) {
      this.items = []
      this.totalAmount = 0
      this.totalVat = 0
    }
    this.customer = {...customer}
  }

  public add(revenue: Revenue) {
    if (this.customer.code !== revenue.customerId) {
      throw new Error('Data Integrity Failed unmatched customer')
    }
    this.items.push(revenue)
    this.totalAmount = revenue.total + this.totalAmount
    this.totalVat = revenue.totalVat + this.totalVat
  }

  public remove(revenueId: string) {
    console.log('Removing', revenueId)
    const index = this.items.findIndex((o) => o.id === revenueId)
    if (index === -1) {
      return
    }
    this.items.splice(index, 1)
    this.items = [...this.items]
    this.totalAmount = this.items.reduce((a, b) => a + b.total, 0)
    this.totalVat = this.items.reduce((a, b) => a + b.totalVat, 0)
  }

  public documentType(): DocumentType {
    return 'invoice'
  }
}
